import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import DynamicFilePreview from "../../elements/DynamicFilePreview";
import useFilePreview from "../../api/api-hooks/records/useFilePreview";
import { FileInterface } from "../../types/RecordInterfaces";
import { downloadFile } from "../../utils/FileUtils";

interface Props {
  isOpen: boolean;
  file: FileInterface;
  closeModal: () => void;
}

export const FileModal = ({ isOpen, file, closeModal }: Props) => {
  const { fileSource, fileType, loading } = useFilePreview(file);
  return (
    <Modal
      className="modal-dialog-centered preview-modal"
      isOpen={isOpen}
      toggle={closeModal}
      size={
        fileType === "Video" || fileType === "Image"
          ? "xl"
          : fileType === "PDF" || fileType === "Text"
          ? "lg"
          : "md"
      }
    >
      <ModalHeader className="w-100  pb-2" toggle={closeModal}>
        File Preview
      </ModalHeader>
      <ModalBody className="p-1">
        <DynamicFilePreview file={file} />
      </ModalBody>
      <ModalFooter className="p-2">
        <Button
          color="secondary"
          data-dismiss="modal"
          type="button"
          onClick={closeModal}
        >
          Close
        </Button>

        <Button
          color="primary"
          onClick={() => downloadFile({ ...file, URL: fileSource })}
          type="button"
        >
          Download File
        </Button>
      </ModalFooter>
    </Modal>
  );
};
